import React, { useEffect, useState } from "react";
import { appAxios } from "../../../axios/axios";
import { IUserData } from "../../../interfaces/userData.interface";
import { IDepartmentStaffMapping } from "../../../interfaces/department.interface";

import { StaffDepartmentList } from "./StaffDepartmentList";
import { ListSkeleton } from "../../Common/Ui/ListSkeleton";

export const DepartmentConfig = () => {
  const [staffList, setStaffList] = React.useState<
    (IUserData & {
      departmentStaffMapping: IDepartmentStaffMapping[];
    })[]
  >([]);

  const [loadingStaffList, setLoadingStaffList] = React.useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const getAllStaff = async () => {
    setLoadingStaffList(true);
    const staffList = await appAxios.post(
      "/query-management-staff/getAllStaffWithDepartment"
    );

    if (staffList.data.success) {
      setStaffList(staffList.data.result);
    }
    setLoadingStaffList(false);
  };

  useEffect(() => {
    getAllStaff();
  }, []);

  return (
    <>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="my-4 col-lg-6">
            <span className="fs-5 fw-bold text-muted">Department Config</span>
            <span className="text-center bg-light ms-3 p-2 small rounded">
              Staff List
            </span>
          </div>
          <div id="search-input" className="col-lg-3">
            <form className="search-btn">
              <input
                className="search-btn"
                type="search"
                placeholder="Search Staff..."
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </form>
          </div>
        </div>
        <div className="row">
          {/* <div className="text-center bg-light p-2 small rounded">
            Staff List
          </div> */}

          {loadingStaffList ? (
            <ListSkeleton count={2} />
          ) : (
            staffList
              .filter((staff) => {
                if (
                  staff.firstName
                    .toLocaleLowerCase()
                    .startsWith(searchQuery.toLowerCase())
                ) {
                  return true;
                }
                return false;
              })
              .map((staff, index) => (
                <StaffDepartmentList key={index} staff={staff} index={index} />
              ))
          )}
        </div>
      </div>
    </>
  );
};
